/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { AdminLogsGetAdminLogsParams } from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Recent log events from the in-process ring buffer (last ~2000).
 */
export const adminLogsGetAdminLogs = (
  params?: AdminLogsGetAdminLogsParams,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<void>({ url: `/admin/logs`, method: 'GET', params, signal }, options);
};

export const getAdminLogsGetAdminLogsQueryKey = (params?: AdminLogsGetAdminLogsParams) => {
  return [`/admin/logs`, ...(params ? [params] : [])] as const;
};

export const getAdminLogsGetAdminLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminLogsGetAdminLogs>>,
  TError = unknown,
>(
  params?: AdminLogsGetAdminLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminLogsGetAdminLogs>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminLogsGetAdminLogsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminLogsGetAdminLogs>>> = ({ signal }) =>
    adminLogsGetAdminLogs(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminLogsGetAdminLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminLogsGetAdminLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminLogsGetAdminLogs>>
>;
export type AdminLogsGetAdminLogsQueryError = unknown;

export function useAdminLogsGetAdminLogs<
  TData = Awaited<ReturnType<typeof adminLogsGetAdminLogs>>,
  TError = unknown,
>(
  params: undefined | AdminLogsGetAdminLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminLogsGetAdminLogs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLogsGetAdminLogs>>,
          TError,
          Awaited<ReturnType<typeof adminLogsGetAdminLogs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminLogsGetAdminLogs<
  TData = Awaited<ReturnType<typeof adminLogsGetAdminLogs>>,
  TError = unknown,
>(
  params?: AdminLogsGetAdminLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminLogsGetAdminLogs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLogsGetAdminLogs>>,
          TError,
          Awaited<ReturnType<typeof adminLogsGetAdminLogs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminLogsGetAdminLogs<
  TData = Awaited<ReturnType<typeof adminLogsGetAdminLogs>>,
  TError = unknown,
>(
  params?: AdminLogsGetAdminLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminLogsGetAdminLogs>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recent log events from the in-process ring buffer (last ~2000).
 */

export function useAdminLogsGetAdminLogs<
  TData = Awaited<ReturnType<typeof adminLogsGetAdminLogs>>,
  TError = unknown,
>(
  params?: AdminLogsGetAdminLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminLogsGetAdminLogs>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminLogsGetAdminLogsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Server-Sent Events stream of log events as they arrive.
 */
export const adminLogsGetAdminLogsStream = (
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<void>({ url: `/admin/logs/stream`, method: 'GET', signal }, options);
};

export const getAdminLogsGetAdminLogsStreamQueryKey = () => {
  return [`/admin/logs/stream`] as const;
};

export const getAdminLogsGetAdminLogsStreamQueryOptions = <
  TData = Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminLogsGetAdminLogsStreamQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>> = ({
    signal,
  }) => adminLogsGetAdminLogsStream(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminLogsGetAdminLogsStreamQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>
>;
export type AdminLogsGetAdminLogsStreamQueryError = unknown;

export function useAdminLogsGetAdminLogsStream<
  TData = Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>,
          TError,
          Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminLogsGetAdminLogsStream<
  TData = Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>,
          TError,
          Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminLogsGetAdminLogsStream<
  TData = Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Server-Sent Events stream of log events as they arrive.
 */

export function useAdminLogsGetAdminLogsStream<
  TData = Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminLogsGetAdminLogsStream>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminLogsGetAdminLogsStreamQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
